import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, useContext } from 'react';
import { Button, CustomInput, Label } from 'reactstrap';
import { ThemeConsumer, ThemeContext } from '../../Basic/ThemeProvider';
import lightImg from './images/lightThemeimage.svg';
import darkImg from './images/darkThemeimage.svg';

var ThemeTogglerButton = function ThemeTogglerButton(props) {
  var prefix = props.prefix,
      currentTheme = props.currentTheme,
      trans = props.trans;

  var callback = function callback(theme) {
    props.userPreferencesCallback({
      changeThemeSuccess: 'success',
      theme: theme
    });
  };

  return /*#__PURE__*/React.createElement(ThemeConsumer, null, function (_ref) {
    var theme = _ref.theme,
        toggleTheme = _ref.toggleTheme;
    return /*#__PURE__*/React.createElement(Button, {
      className: "".concat(prefix, "-profile-save-btn"),
      size: "sm",
      color: "primary",
      disabled: currentTheme === theme,
      onClick: function onClick() {
        toggleTheme();
        callback(currentTheme);
      }
    }, trans('SFxUserPreferencesChangeThemeButtonText'));
  });
};

var Themes = function Themes(_ref2) {
  var prefix = _ref2.prefix,
      trans = _ref2.trans,
      userPreferencesCallback = _ref2.userPreferencesCallback;

  var _useState = useState('dark'),
      _useState2 = _slicedToArray(_useState, 2),
      currentTheme = _useState2[0],
      updateCurrentTheme = _useState2[1];

  var _useContext = useContext(ThemeContext),
      theme = _useContext.theme;

  useEffect(function () {
    updateCurrentTheme(theme);
  }, [theme]);

  var toggleTheme = function toggleTheme(theme) {
    updateCurrentTheme(theme);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-profile-wrap")
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-profile-title")
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(prefix, "-theme-box")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CustomInput, {
    type: "checkbox",
    id: "light",
    label: trans('SFxUserPreferencesLightThemeLabel'),
    checked: currentTheme === 'light',
    onChange: function onChange() {
      return toggleTheme('light');
    }
  }), /*#__PURE__*/React.createElement(Label, {
    for: "light"
  }, /*#__PURE__*/React.createElement("img", {
    className: currentTheme === 'light' ? 'active' : '',
    src: lightImg
  }))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(CustomInput, {
    type: "checkbox",
    id: "dark",
    label: trans('SFxUserPreferencesDarkThemeLabel'),
    checked: currentTheme === 'dark',
    onChange: function onChange() {
      return toggleTheme('dark');
    }
  }), /*#__PURE__*/React.createElement(Label, {
    for: "dark"
  }, /*#__PURE__*/React.createElement("img", {
    className: currentTheme === 'dark' ? 'active' : '',
    src: darkImg
  })))), /*#__PURE__*/React.createElement(ThemeTogglerButton, {
    prefix: prefix,
    currentTheme: currentTheme,
    trans: trans,
    userPreferencesCallback: userPreferencesCallback
  }));
};

export default Themes;